// 订阅状态映射
const SUBSCRIBE_STATUS_MAP = {
  // 关闭订阅
  SUBSCRIBE_CLOSED: 0,
  // 开启订阅
  SUBSCRIBE_OPENED: 1
}

// 最大订阅数
const MAX_SUBSCRIBE_COUNT = 5

// 引导信息映射
const guideInfoMap = {
  // 企微
  weCom: [
    {
      id: 'weCom-1',
      sort: 1,
      title: '打开群聊，点击消息推送',
      description:
        '在企业微信，进入需要接收通知的内部群聊，点击右上角「...」并在工具栏找到「消息推送」入口',
      imgList: ['https://xbb-cplus.oss-cn-hangzhou.aliyuncs.com/webhook/wx/1.png']
    },
    {
      id: 'weCom-2',
      sort: 2,
      title: '添加机器人并输入名称',
      description:
        '在消息推送中点击「添加」，弹出框中为你的机器人起一个响亮的名字，例如“AI 助理”。',
      imgList: ['https://xbb-cplus.oss-cn-hangzhou.aliyuncs.com/webhook/wx/2.png']
    },
    {
      id: 'weCom-3',
      sort: 3,
      title: '复制 Webhook 地址并填入',
      description: `确定保存后，找到 Webhook 地址并点击右侧的复制操作，复制后回到系统中粘贴填入`,
      imgList: ['https://xbb-cplus.oss-cn-hangzhou.aliyuncs.com/webhook/wx/3.png']
    },
    {
      id: 'weCom-4',
      sort: 4,
      title: '复制 Webhook 地址并填入',
      description: '确定保存后，找到 Webhook 地址并点击右侧的复制操作，复制后回到系统中粘贴填入',
      imgList: ['https://xbb-cplus.oss-cn-hangzhou.aliyuncs.com/webhook/wx/4.png']
    }
  ],
  // 钉钉
  dingTalk: [
    {
      id: 'dingTalk-1',
      sort: 1,
      title: ' 打开群聊，点击机器人',
      description: '在钉钉内部群聊，点击右上角「群设置」并找到「机器人」。',
      imgList: ['https://xbb-cplus.oss-cn-hangzhou.aliyuncs.com/webhook/dd/1.png']
    },
    {
      id: 'dingTalk-2',
      sort: 2,
      title: ' 添加机器人选择自定义',
      description: '点击「添加机器人」，下滑找到「自定义」点击并添加。',
      imgList: ['https://xbb-cplus.oss-cn-hangzhou.aliyuncs.com/webhook/dd/2.png']
    },
    {
      id: 'dingTalk-3',
      sort: 3,
      title: '配置自定义机器人',
      description: `填写机器人名字，例如“AI助理”。安全设置勾选“自定义关键词”，填入“AI助理”。`,
      imgList: ['https://xbb-cplus.oss-cn-hangzhou.aliyuncs.com/webhook/dd/3.png']
    },
    {
      id: 'dingTalk-4',
      sort: 4,
      title: '复制 Webhook 地址并填入',
      description: '完成后，找到 Webhook 地址并点击右侧的复制操作，复制后回到系统中粘贴填入',
      imgList: ['https://xbb-cplus.oss-cn-hangzhou.aliyuncs.com/webhook/dd/4.png']
    }
  ],
  // 飞书
  feiShu: [
    {
      id: 'feishu-1',
      sort: 1,
      title: '打开群聊，点击机器人',
      description: '在飞书内部群聊，点击右上角「...」→「设置」→「群机器人」。',
      imgList: ['https://xbb-cplus.oss-cn-hangzhou.aliyuncs.com/webhook/fs/1.png']
    },
    {
      id: 'feishu-2',
      sort: 2,
      title: '添加机器人选择自定义',
      description: '点击「添加机器人」，找到「自定义」点击并配置。',
      imgList: ['https://xbb-cplus.oss-cn-hangzhou.aliyuncs.com/webhook/fs/2.png']
    },
    {
      id: 'feishu-3',
      sort: 3,
      title: '配置自定义机器人',
      description: `填写机器人名字，例如“AI助理”。完成后点击添加。`,
      imgList: ['https://xbb-cplus.oss-cn-hangzhou.aliyuncs.com/webhook/fs/3.png']
    },
    {
      id: 'feishu-4',
      sort: 4,
      title: '复制 Webhook 地址并填入',
      description: '完成后，找到 Webhook 地址并点击右侧的复制操作，复制后回到系统中粘贴填入',
      imgList: ['https://xbb-cplus.oss-cn-hangzhou.aliyuncs.com/webhook/fs/4.png']
    }
  ]
}

/**
 * 处理图片地址
 * @param {Object} data 预览数据
 * @returns {Object} 处理后的预览数据（图片为完整URL地址）
 */
const handleImgURL = (data) => {
  if (!data || !Array.isArray(data)) return data

  const baseUrl = 'https://xbb-cplus.oss-cn-hangzhou.aliyuncs.com/webhook'
  const newData = JSON.parse(JSON.stringify(data))

  newData.forEach((item) => {
    item.imgList = item.imgList.map((img) => {
      if (!img || typeof img !== 'string') return img
      if (/^https?:\/\//.test(img)) return img
      return `${baseUrl}${img}.png`
    })
  })

  return newData
}

/**
 * 获取预览信息
 * @param {String} name 数据项唯一名称
 * @returns {Object|null}
 */
const getPreviewData = (name) => {
  return handleImgURL(guideInfoMap[name]) || null
}

export { SUBSCRIBE_STATUS_MAP, MAX_SUBSCRIBE_COUNT, guideInfoMap, getPreviewData }
